<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Safra
    </div>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <span>Filtros</span>
          </v-card-title>
          <v-card-text>
            
              <!-- <v-col cols="12"> -->
                <v-autocomplete
                  v-model="harvestId"
                  label="Safra"
                  :items="harvestList"
                  item-value="id"
                  item-text="name"
                  @change="loadHarvestExecutionReport"
                />
              <!-- </v-col> -->
            
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <!-- <v-col cols="12"> -->
        <div>
          <BasePrint
            printableElementId="harvestExecutionReportTable"
            printButtonLabel="Imprimir"
            printTitle="Relatório de Safra"
            @start-printing="printing = loading = true"
            @stop-printing="printing = loading = false"
            v-if="harvestExecution"
            class="my-3"
          />
        </div>
      <!-- </v-col> -->
    </v-row>

    <div id="harvestExecutionReportTable" v-if="harvestExecution">
      <v-row >

        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Safra</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{harvestExecution.name}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Status</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{harvestExecution.status}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="periodsHeaders"
            :table-items="harvestExecution.periods.items"
            :indexNested="true"
            :maskFields="periodsHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Ciclos"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="4"><strong class="title">Custo Total</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ this.harvestExecution.periods.cost | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Custo Total</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestExecution.periods.cost | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>

        </v-col>


        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="consumedItemsHeaders"
            :table-items="harvestExecution.consumedItems.items"
            :indexNested="true"
            :maskFields="consumedItemsHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Itens de Operações"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="4"><strong class="title">Valor Total dos Itens Consumidos</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ this.harvestExecution.consumedItems.cost | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Valor Total dos Itens Consumidos</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestExecution.consumedItems.cost | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>

        </v-col>

        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="employeesHeaders"
            :table-items="harvestExecution.employees.items"
            :indexNested="true"
            :maskFields="employeesHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Funcionários"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="3"><strong class="title">Valor Total dos Funcionários</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ this.harvestExecution.employees.cost | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Valor Total dos Funcionários</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestExecution.employees.cost | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>

        </v-col>

        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="patrimoniesHeaders"
            :table-items="harvestExecution.machinery.items"
            :indexNested="true"
            :maskFields="patrimoniesHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Patrimônios Utilizados"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="5"><strong class="title">Valor Total dos Patrimônios</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ this.harvestExecution.machinery.cost | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Valor Total dos Patrimônios</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestExecution.machinery.cost | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>
        
         </v-col>

        <v-col cols="12" class="">
          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="producedProductsHeaders"
            :table-items="harvestExecution.producedProducts.items"
            :indexNested="true"
            :maskFields="producedProductsHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :containTopToolbar="false"
            :hasTableTitle="true"
            tableTitle="Produtos Produzidos"
          >

            <!-- <template slot="tableFooter">
              <tr>
                <td colspan="3"><strong class="title">Total dos Itens Consumidos</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ executionOperation.consumedItemsTotalPrice | formatCurrency }}</strong></td>
              </tr>
            </template> -->

          </BaseIndex>
        </v-col>


        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Custo Estimado</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{numberToCurrency(harvestExecution.estimatedCost)}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- <v-col cols="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Resultado Estimado</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{numberToCurrency(harvestExecution.estimatedResult)}}
              </span>
            </v-card-text>
          </v-card>
        </v-col> -->

      </v-row>
    </div>
    <!-- </div> -->
    
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      tableItems: [],
      harvestExecution: null,
      loading: false,
      pageLoading: false,
      harvestListLoading: false,
      harvestList: [],
      harvestId: null,
      periodsHeaders: [
        { text: 'Talhão', sortable: true, value: 'name' },
        { text: 'Área', sortable: true, value: 'area' },
        { text: 'Status', sortable: true, value: 'status' },
        { text: 'R$ Custo por Ha', sortable: true, value: 'costByHa' },
        { text: 'R$ Custo do Ciclo', sortable: true, value: 'cost' },
      ],
      periodsHeadersMaskFields: [
        { field: 'area', mask: 'number_unit', unit: 'ha'},
        { field: 'cost',mask: 'currency'},
        { field: 'costByHa',mask: 'currency'},
      ],
      consumedItemsHeaders: [
        { text: 'Item', sortable: true, value: 'name' },
        { text: 'Quantidade Total', sortable: true, value: 'quantity' },
        { text: 'Quantidade em Estoque', sortable: true, value: 'stockQuantity' },
        { text: 'Preço Unit.', sortable: true, value: 'unitPrice' },
        { text: 'Preço Total', sortable: true, value: 'cost' },
      ],
      consumedItemsHeadersMaskFields: [
        { field: 'unitPrice', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number'},
        { field: 'stockQuantity', mask: 'number'},
        { field: 'cost',mask: 'currency'}
      ],
      employeesHeaders: [
        { text: 'Colaborador', sortable: true, value: 'name' },
        { text: 'Tempo de Trabalho', sortable: true, value: 'workTime' },
        { text: 'Valor Hora', sortable: true, value: 'hourlyPrice' },
        { text: 'Valor Total', sortable: true, value: 'cost' },
      ],
      employeesHeadersMaskFields: [
        { field: 'hourlyPrice', mask: 'currency'},
        { field: 'cost',mask: 'currency'}
      ],
      patrimoniesHeaders: [
        { text: 'Patrimônio', sortable: true, value: 'patrimonyName' },
        { text: 'Valor Hora Pat.', sortable: true, value: 'patrimonyHourlyPrice' },
        { text: 'Implemento', sortable: true, value: 'implementName' },
        { text: 'Valor Hora Imp.', sortable: true, value: 'implementHourlyPrice' },
        { text: 'Tempo', sortable: true, value: 'totalTime' },
        { text: 'Valor Total', sortable: true, value: 'cost' },
      ],
      patrimoniesHeadersMaskFields: [
        { field: 'patrimonyHourlyPrice', mask: 'currency'},
        { field: 'implementHourlyPrice', mask: 'currency'},
        { field: 'cost',mask: 'currency'}
      ],
      producedProductsHeaders: [
        { text: 'Produto', sortable: true, value: 'name' },
        { text: 'Quantidade Produzida', sortable: true, value: 'quantity' },
      ],
      producedProductsHeadersMaskFields: [
        { field: 'quantity', mask: 'number_unit', unit: 'Kg' },
      ],
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    this.loadAllHarvests();
  },
  mounted() { 
  },
  computed: {
    tableHeaders: function () { }
  },
  methods: {
    loadHarvestExecutionReport: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_HARVEST_EXECUTION_REPORT,
          variables: {
            harvestId: this.harvestId
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.harvestExecution = response.data.accountContext.harvestExecutionReport;
          // console.log("harvestExecution", this.harvestExecution);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadAllHarvests: function() {
        this.harvestListLoading = true;
        this.$apollo
          .query({
            query: LOAD_ALL_HARVEST_QUERY,
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.harvestList = response.data.accountContext.allHarvests;
          })
          .catch(response => console.log(response))
          .finally(() => (this.harvestListLoading = false));
    },
  }
};



const LOAD_HARVEST_EXECUTION_REPORT = gql `
query ($harvestId: ID!) {
  accountContext {
    harvestExecutionReport(harvestId: $harvestId)
  }
}
`;

const LOAD_ALL_HARVEST_QUERY = gql `
  {
    accountContext {
      allHarvests {
        id
        name
      }
    }
  }
`;


</script>

<style scoped>
  ::v-deep .cash_inflow_item {
    color: blue;
  }
  ::v-deep .cash_outflow_item {
    color: red;
  }
  ::v-deep .group_type {
    background-color: #ffdc9d;
    font-weight: bold;
  }
  ::v-deep .direct_cost {
    background-color: #60bd60;
    font-weight: bold;
  }
  ::v-deep .indirect_cost {
    background-color: #60bd60;
    font-weight: bold;
  }

  ::v-deep .total_cost {
    background-color: red;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_cost:hover {
    color: black;
  }
  
  ::v-deep .area_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .area_cost:hover {
    color: black;
  }

  ::v-deep .unit_production_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_production_cost:hover {
    color: black;
  }
  
  ::v-deep .unit_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_cost:hover {
    color: black;
  }
  
  
  ::v-deep .total_revenue {
    background-color: #007eff;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_revenue:hover {
    color: black;
  }

  ::v-deep .period_result {
    background-color: yellow;
  }

  ::v-deep .area_result {
    background-color: yellow;
  }
  ::v-deep .unit_result {
    background-color: yellow;
  }
  ::v-deep .net_income {
    background-color: yellow;
  }
</style>
